import { render, staticRenderFns } from "./GridReport.vue?vue&type=template&id=2a2ec8b1"
import script from "./GridReport.vue?vue&type=script&lang=js"
export * from "./GridReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports